import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  FIRST_401_ERROR,
  REFRESH_IN_PROGRESS,
  TOKEN_DATA_LOCALSTORAGE_KEY,
} from '@core/const/const';
import { AppRouting, AuthExemptEndpoint } from '@core/enums';
import { HttpAuth } from '@core/services/http-auth';
import { catchError, switchMap, throwError, EMPTY } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const httpAuth = inject(HttpAuth);

  if (req.url.includes(`/${AuthExemptEndpoint.Email}`)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        const retryFlag = localStorage.getItem(FIRST_401_ERROR);
        const refreshInProgress = localStorage.getItem(REFRESH_IN_PROGRESS);

        if (!retryFlag && !refreshInProgress) {
          localStorage.setItem(REFRESH_IN_PROGRESS, 'true');
          localStorage.setItem(FIRST_401_ERROR, 'true');
          return httpAuth.refreshToken().pipe(
            switchMap((newTokenData) => {
              localStorage.removeItem(REFRESH_IN_PROGRESS);
              localStorage.setItem(TOKEN_DATA_LOCALSTORAGE_KEY, JSON.stringify(newTokenData));

              const retried = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newTokenData.token}`,
                },
              });

              return next(retried);
            }),
            catchError(() => {
              localStorage.removeItem(REFRESH_IN_PROGRESS);
              cleanAndRedirect(router);
              return EMPTY;
            })
          );
        } else {
          if (cleanAndRedirect(router)) {
            return EMPTY;
          }
          return throwError(() => err);
        }
      }

      return throwError(() => err);
    })
  );
};

function cleanAndRedirect(router: Router) {
  localStorage.removeItem(TOKEN_DATA_LOCALSTORAGE_KEY);
  localStorage.removeItem(FIRST_401_ERROR);

  if (localStorage.getItem(REFRESH_IN_PROGRESS) === null) {
    window.location.href = `/${AppRouting.Login}`;
    return true;
  }
  return false;
}
